export const WEB_SOCKET_HOST = process.env.REACT_APP_ENV_CHAT_WEB_SOCKET_HOST;
export const WEB_API_HOST = process.env.REACT_APP_ENV_CHAT_WEB_API_HOST;
